<template>
  <div>
    <BulletinView ref="bulletinView" v-model="selectedBulletin" :editable="false"></BulletinView>
    <b-row>
      <b-col cols="12">
        <FITFormCard style="width: 100%; height: 100% ;">
          <div slot="header">
            <b-row align-v="center">
              <b-col cols="6">
                <h5>{{ $t('home.message.headers.bulletin') }}</h5>
              </b-col>
              <b-col cols="6" class="text-right">
                <!--  <b-button variant="primary" size="sm" style="margin: 0" @click="createBulletin">
              <i class="fa fa-edit mr-2"></i> {{ $t('home.message.createBulletin') }}
            </b-button> -->
              </b-col>
            </b-row>
          </div>
          <div slot="formBody" class="p-2" style="min-height: 44vh; max-height: 44vh; ">
            <b-row class="text-center" align-h="between" align-v="center">
              <b-col cols="4">
                <FITSelect :label="$t('adm.bulletin.category')" :width="8" v-model="form.category" :options="getTranslatedArray($i18n.locale, 'Adm', 'category', true)"></FITSelect>
              </b-col>
              <b-col cols="4">
                <FITSelect :label="$t('adm.bulletin.provider')" :width="8" v-model="form.providerID" :options="getTranslatedArray($i18n.locale, 'Adm', 'providerID', true)"></FITSelect>
              </b-col>
              <b-col cols="4">
                <FITSelect :label="$t('adm.bulletin.policyType')" :width="8" v-model="form.policyType" :options="getTranslatedArray($i18n.locale, 'Adm', 'policyType', true)"></FITSelect>
              </b-col>
            </b-row>
            <div style="width: 100; height: 35vh;  overflow-y: auto">
              <b-progress :value="100" variant="warning" :animated="true" class="mb-3" v-if="isLoading"></b-progress>
              <b-table hover small responsive class="borderless" :fields="fields" :items="items" tbody-tr-class="border-light border-bottom" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10" infinite-scroll-immediate-check="false" @row-clicked="didSelectTableRow">
                <template slot="subject" slot-scope="data">
                  <span class="text-truncate h6 py-2">{{ data.value }}</span>
                  <!-- <p class="mb-0">{{ data.item.preview }}</p> -->
                </template>
                <template slot="updateTime" slot-scope="data">
                  <span>{{data.value | date}}</span>
                  <!-- <span class="py-2">{{ data.value | date }}</span> -->
                  <!-- <p>{{ getConvertedCategory(data.item.category) }}</p> -->
                </template>
              </b-table>
            </div>
          </div>
        </FITFormCard>
      </b-col>
    </b-row>
  </div>
</template>
<script type="text/javascript">
import {
  FITFormCard,
  FITButton,
  FITModal,
  FITSelect
} from '@/components'

import BulletinView from './BulletinView'

import infiniteScroll from 'vue-infinite-scroll'
import Vue from 'vue'
import { mapGetters } from 'vuex';
export default {
  name: 'BulletinList',
  components: {
    FITFormCard,
    FITButton,
    FITModal,
    BulletinView,
    FITSelect
  },
  directives: {
    infiniteScroll
  },

  computed: {
    ...mapGetters('Homepage', [
      'getTranslated'
    ]),
    ...mapGetters(['getTranslatedArray', 'getTranslatedValue']),
    categories() {
      return this.getTranslated(this.$i18n.locale, 'category');
    }
  },
  methods: {
    createBulletin() {
      console.debug(this.$route);
      this.$router.push('/hm/create');
    },
    reload() {
      Vue.set(this, 'currentPage', 0);
      // Vue.set(this, 'busy', true);
      Vue.set(this, 'items', []);
      this.loadMore();
    },

    loadMore() {
      Vue.set(this, 'isLoading', true);
      var form = {
        count: 20,
        page: this.currentPage + 1
      }
      form = {
        ...form,
        ...this.form
      }

      let params = {}
      Object.keys(form)
        .forEach((key) => {
          if (form[key]) {
            params[key] = form[key];
          }
        });
      this.$store.dispatch('Homepage/getBulletinList', params).then((json) => {
        let item = this.items;
        item = [
          ...this.items,
          ...json.list
        ];
        Vue.set(this, 'currentPage', this.currentPage + 1);

        Vue.set(this, 'items', item);
        Vue.set(this, 'isLoading', false);
        // if (this.busy) {
        //   Vue.set(this, 'busy', false)
        // }
      }).catch((err) => {
        console.error(err);
      });
    },

    didSelectTableRow(item, index, event) {
      Vue.set(this, 'selectedBulletin', item);
      console.debug(item.ID)
      this.$refs.bulletinView.show(item.ID);
    },

    getConvertedCategory(key) {
      let result = this.categories.filter((item) => {
        return item.value === key;
      });

      if (result.length > 0) {
        return result[0].text;
      }

      return 'N/A';
    },
  },
  data() {
    return {
      isLoading: true,
      selectedBulletin: {
        subject: ''
      },
      fields: [
        { key: 'subject', class: 'w-75', thClass: 'd-none', tdClass: 'py-2 align-middle' },
        { key: 'updateTime', thClass: 'd-none', tdClass: 'text-right py-2 align-middle' }
      ],
      busy: false,
      currentPage: 0,
      items: [],
      form: {
        providerID: null,
        policyType: null,
        category: null,
      }
    }
  },
  watch: {
    form: {
      deep: true,
      handler: function(newData, oldData) {
        this.reload();
      }
    }
  },

  created() {
    this.loadMore();
    this.$store.dispatch('getAllSelections', 'bulletin')
      .then((json) => {
        this.$store.commit({
          type: 'Adm/setSelections',
          selections: json.data
        });
      });
  }
}

</script>
<style>
.borderless td,
.borderless th {
  border: none;
}

.borderless td {
  cursor: pointer
}

</style>



// WEBPACK FOOTER //
// src/Homepage/components/Bulletin/BulletinList.vue